import { ServiceTypeRegionUpsertDialogStore } from './service-type-region-upsert-dialog.store';
import { fb } from '../../../../../modules/shared/shared.global-service';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { Validators } from '@angular/forms';
import { dateify } from '../../../../../modules/shared/helpers/date.helper';
import { isInvalid } from '../../../../../modules/shared/helpers/validate';
import { contentGlobalSuccess } from '../../../../../modules/content/content.error';
import {
    SocialServiceRegionPatchInput,
} from '@libs/types/src/services/input-type/services/social-service/social-service-region.patch-input';
import {
    SocialServiceRegionCreateInput,
} from '@libs/types/src/services/input-type/services/social-service/social-service-region.create-input';
import { DateInputComponent } from '../../../../kit/input/date-input/date-input.component';
import { TextInputComponent } from '../../../../kit/input/text-input/text-input.component';
import { SelectInputComponent } from '../../../../kit/input/select-input/select-input.component';
import { socialServiceMpsvRegionEnumOptions } from '@libs/types/src/services/enum/social-service-mpsv-region.enum';
import { TextAreaInputComponent } from '../../../../kit/input/text-area-input/text-area-input.component';

@Component({
    selector: 'app-service-type-region-upsert-dialog',
    templateUrl: './service-type-region-upsert-dialog.component.html',
    styleUrl: './service-type-region-upsert-dialog.component.scss',
    providers: [ServiceTypeRegionUpsertDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        DateInputComponent,
        TextInputComponent,
        SelectInputComponent,
        TextAreaInputComponent,
    ],
})
export class ServiceTypeRegionUpsertDialogComponent extends BaseDialogComponent {

    public readonly store = inject(ServiceTypeRegionUpsertDialogStore);

    protected prefix = 'serviceType.region.';

    protected form = fb.group({
        name: fb.control<string | null>(null, Validators.required),
        description: fb.control<string>('', { nonNullable: true }),
        mpsvRegion: fb.control<string | null>(null, Validators.required),
        billCode: fb.control<string | null>(null),
        validFrom: fb.control<Date | null>(null),
        validTo: fb.control<Date | null>(null),
    });

    constructor() {
        super();
        const region = this.dialogConfig.data.region;
        if (region) {
            this.form.patchValue({
                ...region,
                validFrom: dateify(region.validFrom),
                validTo: dateify(region.validTo),
            });
        }
    }

    public override async save(): Promise<void> {
        if (isInvalid(this.form)) return;

        const id = this.dialogConfig.data.region?.id;
        const _data = {
            ...this.form.getRawValue(),
        } as any;

        if (id) {
            const data = _data as SocialServiceRegionPatchInput;
            data.id = id;
            await this.store.api.patchSocialServiceRegion(data, 'id');
            contentGlobalSuccess.next('common.updated');
        } else {
            const data = _data as SocialServiceRegionCreateInput;
            data.serviceTypeId = this.store.serviceType().id;
            await this.store.api.createSocialServiceRegion(data, 'id');
            contentGlobalSuccess.next('common.created');
        }

        this.dialogRef.close(true);
    }

    protected readonly socialServiceMpsvRegionEnumOptions = socialServiceMpsvRegionEnumOptions;
}
